import React, { useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import '../AdvanceDropdownMenu/advanceDropdownMenu.css';

import Humburger from '../../pictures/humberger-menu.png';
import CloseCross from '../../pictures/green-cross.png';
import { ReactComponent as RightArrow } from '../../pictures/right_arrow.svg';
import { ReactComponent as LeftArrow } from '../../pictures/left_arrow.svg';
import { HashLink } from 'react-router-hash-link';
import Text from '../Text/index';

const AdvanceDropdownMenu = () => {
  return (
    <Navbar>
      <NavItem>
        <DropdownMenuAdvance></DropdownMenuAdvance>
      </NavItem>
    </Navbar>
  );
};

function Navbar(props) {
  return (
    <nav className="navbar">
      <ul className="navbar-nav">{props.children}</ul>
    </nav>
  );
}

function NavItem(props) {
  const [open, setOpen] = useState(false);
  const [clicked, setClicked] = useState(false);
  const handleIconClick = () => {
    setClicked((curr) => !curr);
  };
  return (
    <li className="nav-item">
      <a href={props.link} onClick={() => setOpen(!open)}>
        <button className="nav-item_btn" onClick={handleIconClick}>
          {clicked ? (
            <img src={CloseCross} alt="" />
          ) : (
            <img src={Humburger} alt="" />
          )}
        </button>
      </a>

      {open && props.children}
    </li>
  );
}

function DropdownMenuAdvance() {
  const [activeMenu, setActiveMenu] = useState('main');
  const [menuHeight, setMenuHeight] = useState(null);

  function calcHeight(el) {
    const height = el.offsetHeight;
    setMenuHeight(height);
  }

  function DropdownItem(props) {
    return (
      <HashLink
        to={props.link}
        href={props.link}
        className="menu-item"
        onClick={() => props.goToMenu && setActiveMenu(props.goToMenu)}
      >
        <span className="icon-button">{props.leftIcon}</span>
        {props.children}
        <span className="icon-right">{props.rightIcon}</span>
      </HashLink>
    );
  }

  return (
    <div className="dropdown" style={{ height: menuHeight }}>
      <CSSTransition
        in={activeMenu === 'main'}
        timeout={500}
        classNames="menu-primary"
        unmountOnExit
        onEnter={calcHeight}
      >
        <div className="menu">
          <span id="MENU">Меню</span>
          <DropdownItem rightIcon={<RightArrow />} goToMenu="uslugi">
            Наши работы
          </DropdownItem>
          <DropdownItem rightIcon={<RightArrow />} goToMenu="oborudovanie">
            Оборудование
          </DropdownItem>
          <DropdownItem>
            <HashLink to="/dostavka">
              <Text component="span" section="link">
                Доставка и оплата
              </Text>
            </HashLink>
          </DropdownItem>
          <DropdownItem>
            <HashLink to="/fill_the_form">
              <Text component="span" section="link">
                Контакты
              </Text>
            </HashLink>
          </DropdownItem>
          <DropdownItem>
            <HashLink to="/okompanuu">
              <Text component="span" section="link">
                О компании
              </Text>
            </HashLink>
          </DropdownItem>
          {/* <DropdownItem>Информация о юридическом лице</DropdownItem> */}
        </div>
      </CSSTransition>

      <CSSTransition
        in={activeMenu === 'oborudovanie'}
        timeout={500}
        classNames="menu-secondary"
        unmountOnExit
        onEnter={calcHeight}
      >
        <div className="menu">
          <DropdownItem goToMenu="main" leftIcon={<LeftArrow />}>
            <p>Назад</p>
          </DropdownItem>
          <DropdownItem link="/equipping#equipping_TDM">
            TDM ELECTRIC
          </DropdownItem>
          <DropdownItem link="/equipping#equipping_EKF">EKF</DropdownItem>
          <DropdownItem link="/equipping#equipping_DKC">DKC</DropdownItem>
          <DropdownItem link="/equipping#equipping_SystemElectric">
            SYSTEME ELECTRIC
          </DropdownItem>
          <DropdownItem link="/equipping#equipping_ABB">ABB</DropdownItem>
          <DropdownItem link="/equipping#equipping_IEK">IEK</DropdownItem>
          <DropdownItem link="/equipping#equipping_OSTEC">OSTEC</DropdownItem>
          <DropdownItem link="/equipping#equipping_Legrand">
            LEGRAND
          </DropdownItem>
          <DropdownItem link="/equipping#equipping_DEKraft">
            DEKRAFT
          </DropdownItem>
          <DropdownItem link="/equipping#equipping_КЭАЗ">
            PHOENIX CONTACT
          </DropdownItem>
          <DropdownItem link="/equipping#equipping_PhoenixContact">
            КЭАЗ
          </DropdownItem>
          <DropdownItem link="/equipping#equipping_WEIDMULLER">
            WEIDMULLER
          </DropdownItem>
          <DropdownItem link="/equipping#kontrollery_SIEMENS">
            SIEMENS
          </DropdownItem>
          <DropdownItem link="/equipping#kontrollery_UNITRINICS">
            UNITRINICS
          </DropdownItem>
          <DropdownItem link="/equipping#kontrollery_ONI">ONI</DropdownItem>
          <DropdownItem link="/equipping#kontrollery_HELMHOLZ">
            HELMHOLZ
          </DropdownItem>
          <DropdownItem link="/equipping#kontrollery_OBEH">OBEH</DropdownItem>
          <DropdownItem link="/equipping#kontrollery_GCAN">GCAN</DropdownItem>
          <DropdownItem link="/kontrollery_SEGNETICS">SEGNETICS</DropdownItem>
        </div>
      </CSSTransition>

      <CSSTransition
        in={activeMenu === 'uslugi'}
        timeout={500}
        classNames="menu-secondary"
        unmountOnExit
        onEnter={calcHeight}
      >
        <div className="menu">
          <DropdownItem goToMenu="main" leftIcon={<LeftArrow />}>
            <p>Назад</p>
          </DropdownItem>
          <DropdownItem link="/services#redcupboard">
            Шкаф управления пожарной насосной станцией
          </DropdownItem>
          <DropdownItem link="/services#cupboard_wastewater">
            Шкаф управления задвижками на очистных сооружениях
          </DropdownItem>
          <DropdownItem link="/services#cupboard_station">
            Шкаф управления насосной станцией
          </DropdownItem>
          <DropdownItem link="/services#cupboard_leathergoods">
            Шкаф автоматики установкой разогрева элементов формовки кожаных
            перчаток
          </DropdownItem>
          <DropdownItem link="/services#cupboard_ventilation">
            Шкаф управления системы вентиляции
          </DropdownItem>
          <DropdownItem link="/services#cupboard_ABP">
            Силовой шкаф учета с устройством АВР
          </DropdownItem>
          <DropdownItem link="/services#cupboard_swiming">
            Шкаф автоматики плавучей насосной станции с управлением пo
            радиоканалу
          </DropdownItem>
          <DropdownItem link="/services#cupboard_ribbon">
            Шкаф автоматики и управления конвейерными лентами
          </DropdownItem>
          <DropdownItem link="/services#cupboard_firesafary">
            Шкаф управления пожарной насосной станцией на релейной автоматике
          </DropdownItem>
          <DropdownItem link="/services#cupboard_clean">
            Шкаф управления задвижками на очистных сооружениях
          </DropdownItem>
        </div>
      </CSSTransition>
    </div>
  );
}
export default AdvanceDropdownMenu;
